import { Suspense } from 'react';
import { DisputesClient } from './disputes-client';

export const metadata = { title: 'Disputes | Admin' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <DisputesClient />
    </Suspense>
  );
}
